import { useEffect, useMemo } from "react";
import styles from "./viewLesson.module.scss";
import { useGetUnitInfoByUniqueNameLazyQuery } from "@api/graphql-codegen";
import { useLocation, useHistory } from "react-router-dom";
import UnitProgressModal from "@src/components/unit-progress-modal/UnitProgressModal";
import Spinner from "@src/components/spinner/Spinner";
import { useRolesPermissions } from "@src/hooks";
import { UserRoleEnum } from "@src/types";

const ViewLesson = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const unitUniqueName = pathname.split("/")[1];
  const lessonUniqueName = pathname.split("/")[2];

  const isSuperAdmin = useRolesPermissions([UserRoleEnum.SuperAdmin]);
  const isAdmin = useRolesPermissions([
    UserRoleEnum.Admin,
    UserRoleEnum.DistrictAdmin,
  ]);

  const [getUnits, { data, loading }] = useGetUnitInfoByUniqueNameLazyQuery({fetchPolicy: "network-only",
    onCompleted(data) {
      if (!data.getUnitInfoByUniqueName) {
        history.push("/dashboard");
      }
    },
    onError() {
      if (unitUniqueName === 'lessons') {
        history.push("/lessons?tab=programs");
        return;
      }
      history.push("/dashboard");
    }
  });

  useEffect(() => {
    if (unitUniqueName) {
      getUnits({
        variables: {
          input: {
            uniqueName: unitUniqueName,
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitUniqueName]);

  const handleCloseModal = (isCRC?: boolean | null | undefined) => {
    history.goBack();
  };

  const lessonInfo = useMemo(() => {
    return data?.getUnitInfoByUniqueName?.classPresentation?.find(
      (lesson) => lesson?.uniqueName === lessonUniqueName
    );
  }, [data?.getUnitInfoByUniqueName, lessonUniqueName])

  return (
    <div className={styles.page}>
      {loading ? (
        <div className={styles.spinner}>
          <Spinner />
        </div>
      ) : data?.getUnitInfoByUniqueName ? (
        <UnitProgressModal
          open
          onClose={handleCloseModal}
          unitId={data?.getUnitInfoByUniqueName.id || ""}
          unitData={data?.getUnitInfoByUniqueName}
          isDashboard
          lessonInfoByUniqueName={lessonInfo}
        />
      ) : null}
    </div>
  );
};

export default ViewLesson;
